<page-error-state *ngIf="!pscs.shoppingCartShowLoader" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission('READ')" pageName="Marketplace"></page-error-state>
<div class="marketplace-overlay" *ngIf="pscs.shoppingCartShowLoader">
    <sol-spinner class="marketplace-loader" [showSpinner]="true"></sol-spinner>
</div>
<div *ngIf="hasPermission('READ') && !noPMLicense">
    <div class="container" id="custom-container-mkt-sc">
        <h1 id="page-title" cvLocalizedText langSection="MarketPlace" langKey="Menu_Header">Marketplace</h1>
    </div>
    <div #cvMarketplaceContainer id="cv-marketplace-container" class="container" 
        [ngClass]="{'cxone-horizontal-scroll': isCxone && !pscs.shoppingCartIsProductSelected, 'cxone-scroll-cv-marketplace-sc': isCxone,
        'cxone-horizontal-scroll-product-detail': pscs.shoppingCartIsProductSelected && isCxone}">
        <div class="container right-header-items-container" [ngStyle]="{'width': headerRightContentWidth }">
            <div id="right-header-items-search" class="cx-one-ui">
                <div class="justify-content-end search-container cxone-live-search">
                    <!--Search-->
                    <sol-text-input id="marketplaceSearch" type="search" [ngStyle]="{
                            'width': headerSearchBarWidth
                        }" autocomplete="off" placeholder="{{getLocalizationString('Search_Products','Search products')}}"
                        class="header-search-bar" [(ngModel)]="filterMatchProduct" [maxlength]=""
                        (ngModelChange)="checkFilterLength($event)">
                    </sol-text-input>
                    <i class="icon-search" [hidden]="filterMatchProduct.length !== 0">
                        <svg class="icon-16 fill-iconDefault search-wrapper">
                            <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                        </svg>
                    </i>
                    <i class="icon-search" [hidden]="filterMatchProduct.length === 0" (click)="resetFilterLabel()">
                        <svg class="icon-12 fill-iconDefault close-wrapper">
                            <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                        </svg>
                    </i>
                </div>
            </div>

            <!-- Profile and Coin Count -->
            <div class="marketplace-header-coin-container text-truncate">
                <svg class="marketplace-header-coin">
                    <use href="../App_Themes/CXone/icons/coins.svg#coins"></use>
                </svg>
                <span
                    title="{{pscs.fullGammificationProfile?.AvailableSpendingPoints | cvNumberLocalize}} {{ (getLocalizationString('Coins','coins')).toLowerCase()}}">
                    {{pscs.fullGammificationProfile?.AvailableSpendingPoints | cvNumberLocalize}}
                    <span class="text-lowercase">{{pscs.fullGammificationProfile?.AvailableSpendingPoints === 1 ? getLocalizationString('Coin','coin') : getLocalizationString('Coins','coins')}}</span>
                </span>
            </div>
            <!-- Shopping Cart -->
            <div id="store-cart-icon" class="marketplace-header-cart-container">
                <svg class="marketplace-header-cart-icon" (click)="goToCart()">
                    <use href="../App_Themes/CXone/icons/cart.svg#cart"></use>
                </svg>
                <div id="marketplace-cart-icon" (click)="goToCart()">
                    <div id="marketplace-cart-icon-red-circle"
                        *ngIf="getCurrentShoppingCart() > 0 || getCurrentShoppingCart() == '99+'">
                        <span [ngClass]="{ 'marketplace-cart-icon-plus' : getCurrentShoppingCart() == '99+'}">{{
                            getCurrentShoppingCart() }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- My cart table-->
        <div id="marketplace-cart-products" *ngIf="pscs.pointStoreVisibleContent.showShoppingCartPage">
            <div class="row h-100">
                <div class="col-12 cx-one-ui">
                    <cv-shopping-cart-list (backToBrowseEvent)="backToBrowse()" (goToOrdersEvent)="goToOrders()"
                        (setSelectedImageEvent)="callAndSetSelectedImage()"></cv-shopping-cart-list>
                </div>
            </div>
        </div>

        <!--Cart Drawer-->

        <cv-marketplace-cart-drawer [autoHideScrollbar]="false"
            [pointStoreProducts]="pscs.pointStoreCart.pointStoreProducts" [highlightCartItem]="highlightCartItem"
            [products]="pscs.pointStoreProducts" [lastAdded]="lastAdded" (deleteItem)="deleteItemFromCart($event)"
            (goToCartEvent)="goToCart()">
        </cv-marketplace-cart-drawer>

        <sol-tabs *ngIf="shouldRefreshTabs">
            <sol-tab id="home-tab" [title]="getLocalizationString('Home_Tab', 'HOME')"
                [isActive]="selectedTab[0].selected" #hometab>
                <overlay-scrollbars *ngIf="pscs.shoppingCartIsProductSelected && hometab.isActive && pscs.shoppingCartProducts.length > 0"
                    [options]="scrollOptions" class="h-100">
                    <div class="row">
                        <div class="col-12">
                            <cv-marketplace-shopping-cart-product-details (showValidationMsg)="showValidationMsg($event)"
                                (resetQtyInput)="shoppingCartCarouselComponent.resetQtyInput()"
                                (setSelectedImageEvent)="callAndSetSelectedImage()"></cv-marketplace-shopping-cart-product-details>
                        </div>
                    </div>
                </overlay-scrollbars>
                <overlay-scrollbars id="marketplace-home-tab-content" class="cv-marketplace-tab-content h-100"
                    [options]="homeScrollOptions" *ngIf="hometab.isActive" [hidden]="pscs.shoppingCartIsProductSelected">
                    <div class="row" *ngIf="pscs.shoppingCartProducts.length > 0">
                        <div class="col-12 carousel-tag-container">
                            <cv-marketplace-shopping-cart-carousel #shoppingCartCarousel
                                (showValidationMsg)="showValidationMsg($event)"
                                [contentDisplayed]="pscs.shoppingCartIsProductSelected"></cv-marketplace-shopping-cart-carousel>
                        </div>
                        <div class="col-12 h-100">
                            <cv-marketplace-shopping-cart-featured (showValidationMsg)="showValidationMsg($event)"
                                (clearSearch)="resetFilterLabel(false)"
                                class="w-100 featured-tag"></cv-marketplace-shopping-cart-featured>
                        </div>
                    </div>
                    <!--Empty state-->
                    <div class="row h-100" *ngIf="pscs.shoppingCartProducts.length == 0 && !pscs.shoppingCartShowLoader">
                        <div class="col-12 d-flex justify-content-center align-items-center flex-column">
                            <svg class="">
                                <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                            </svg>
                            <div class="empty-state-msg">
                                <label class="d-block" class="welcome-msg" cvLocalizedText langSection="MarketPlace"
                                    langKey="Welcome_Marketplace">Welcome to Marketplace</label>
                                <label class="d-block" cvLocalizedText langSection="MarketPlace"
                                    langKey="Empty_State_Message">We will bring you some amazing products shortly</label>
                            </div>
                        </div>
                    </div>
                </overlay-scrollbars>
            </sol-tab>
            <sol-tab id="shop-by-category-tab" [title]="getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY')"
                [isActive]="selectedTab[1].selected" #categoriesTab>
                <overlay-scrollbars *ngIf="pscs.shoppingCartIsProductSelected && categoriesTab.isActive"
                    [options]="scrollOptions" class="h-100">
                    <div class="row">
                        <div class="col-12">
                            <cv-marketplace-shopping-cart-product-details (showValidationMsg)="showValidationMsg($event)"
                                (setSelectedImageEvent)="null"></cv-marketplace-shopping-cart-product-details>
                        </div>
                    </div>
                </overlay-scrollbars>
                <overlay-scrollbars id="marketplace-categories-tab-content" class="cv-marketplace-tab-content"
                    [options]="scrollOptions" *ngIf="categoriesTab.isActive" [hidden]="pscs.shoppingCartIsProductSelected">
                    <div class="row h-100">
                        <div class="cv-left-filter marketplace-shop-by-category-content mkpsbycc-left">
                            <cv-marketplace-filter (clearSearch)="resetFilterLabel(false)" id="marketplace-filter-content"
                                #filters [textFilter]="filterMatchProduct"
                                (updateSelectedTags)="categories.modifySelectedTags($event)"
                                (sortFunction)="categories.sortProducts($event)"></cv-marketplace-filter>
                        </div>
                        <div class="marketplace-shop-by-category-content mkpsbycc-right">
                            <cv-marketplace-shopping-cart-categories-landing (showValidationMsg)="showValidationMsg($event)"
                                #categories [textFilter]="filterMatchProduct" [selectedCategory]="filters.selectedCategory"
                                (clearAllFilters)="filters.clearAll()"
                                (updateFilters)="filters.updateFilters($event)"></cv-marketplace-shopping-cart-categories-landing>
                        </div>
                    </div>
                </overlay-scrollbars>
            </sol-tab>
            <sol-tab id="wishlist-tab" [title]="getLocalizationString('Wishlist_Tab', 'WISHLIST')"
                [isActive]="selectedTab[2].selected" #wishlistTab>
                <overlay-scrollbars *ngIf="pscs.shoppingCartIsProductSelected && wishlistTab.isActive"
                    [options]="scrollOptions" class="h-100">
                    <div class="row">
                        <div class="col-12">
                            <cv-marketplace-shopping-cart-product-details (showValidationMsg)="showValidationMsg($event)"
                                (setSelectedImageEvent)="null"></cv-marketplace-shopping-cart-product-details>
                        </div>
                    </div>
                </overlay-scrollbars>
                <overlay-scrollbars id="marketplace-wishlist-tab-content" class="cv-marketplace-tab-content"
                    [options]="scrollOptions" *ngIf="wishlistTab.isActive" [hidden]="pscs.shoppingCartIsProductSelected">
                    <div class="row h-100 wishlist-tab-container">
                        <div class="col-12">
                            <cv-marketplace-shopping-cart-wishlist (showValidationMsg)="showValidationMsg($event)"
                                (clearSearch)="resetFilterLabel(false)"></cv-marketplace-shopping-cart-wishlist>
                        </div>
                    </div>
                </overlay-scrollbars>
            </sol-tab>
            <sol-tab id="orders-tab" [title]="getLocalizationString('Orders_Tab', 'ORDERS')"
                [isActive]="selectedTab[3].selected" #ordersTab>
                <overlay-scrollbars id="marketplace-wishlist-tab-content" class="cv-marketplace-tab-content"
                    [options]="scrollOptions" *ngIf="ordersTab.isActive && !hideOrdersTab">
                <cv-marketplace-shopping-cart-orders class="w-100 h-100" (clearSearch)="resetFilterLabel(false)"
                    *ngIf="ordersTab.isActive && !hideOrdersTab"></cv-marketplace-shopping-cart-orders>
                </overlay-scrollbars>
            </sol-tab>
        </sol-tabs>
    </div>
</div>
